<template>
  <div class="field" :style="field.style">
    <div class="mb-2 is-flex is-justify-content-space-between is-align-items-center">
      <label class="mb-0 label">{{ field.label }}{{ field.required ? " *" : "" }}</label>
      <a v-if="hasDownloadableImages" href="" class="button is-small is-light" @click.prevent="downloadAllImages"> <i class="mr-1 fa fa-download"></i>Shkarko të gjitha </a>
    </div>

    <div class="gap-2 mb-2 is-flex is-flex-wrap-wrap">
      <div v-for="(img, idx) in existing_images" :key="'exist_' + img.id" class="relative p-1 border rounded" style="width: 100px; height: 120px">
        <div class="image-preview" :style="{ backgroundImage: 'url(' + img.url + ')' }" style="height: 80px; background-size: cover; background-position: center"></div>
        <div class="justify-between mt-1 is-flex">
          <span class="text-xs cursor-pointer" :class="img.is_main ? 'text-green-600 font-bold' : 'text-gray-400'" @click="setMain(idx, 'existing')" title="Foto kryesore">
            <i class="fa fa-star"></i>
          </span>
          <span class="text-xs text-blue-600 cursor-pointer" @click="downloadImage(img, idx, 'existing')" title="Shkarko">
            <i class="fa fa-download"></i>
          </span>
          <span class="text-xs text-red-500 cursor-pointer" @click="markForDeletion(idx)" title="Fshi">
            <i class="fa fa-trash"></i>
          </span>
        </div>
      </div>

      <div v-for="(img, idx) in new_images_preview" :key="'new_' + idx" class="relative p-1 border border-blue-300 rounded" style="width: 100px; height: 120px">
        <div class="image-preview" :style="{ backgroundImage: 'url(' + img.url + ')' }" style="height: 80px; background-size: cover; background-position: center"></div>
        <div class="justify-between mt-1 is-flex">
          <span class="text-xs cursor-pointer" :class="img.is_main ? 'text-green-600 font-bold' : 'text-gray-400'" @click="setMain(idx, 'new')" title="Foto kryesore">
            <i class="fa fa-star"></i>
          </span>
          <span class="text-xs text-blue-600 cursor-pointer" @click="downloadImage(img, idx, 'new')" title="Shkarko">
            <i class="fa fa-download"></i>
          </span>
          <span class="text-xs text-red-500 cursor-pointer" @click="removeNew(idx)" title="Hiq">
            <i class="fa fa-times"></i>
          </span>
        </div>
        <span class="absolute top-0 right-0 bg-blue-500 text-white text-[8px] px-1">New</span>
      </div>

      <div
        class="border border-gray-400 border-dashed rounded cursor-pointer is-flex is-justify-content-center is-align-items-center hover:bg-gray-100"
        style="width: 100px; height: 120px"
        @click="$refs.fileInput.click()"
      >
        <div class="text-center text-gray-500">
          <i class="fa fa-plus fa-2x"></i><br />
          <span class="text-xs">Shto Foto</span>
        </div>
      </div>
    </div>

    <input type="file" ref="fileInput" multiple accept="image/jpeg,image/png,image/webp,image/gif,.jpg,.jpeg,.png,.webp,.gif" class="hidden" style="display: none" @change="handleFiles" />

    <p class="help has-text-grey">Formate: JPG, PNG, WEBP, GIF. Madhësia maksimale: {{ maxSizeLabel }} për foto.</p>
    <p v-if="uploadError" class="help is-danger">{{ uploadError }}</p>
    <p v-if="false && field.required && !hasImages" class="help is-danger">{{ field.required_text || "E detyrueshme" }}</p>
  </div>
</template>

<script>
import ProductsServices from "@/services/Product";

const ALLOWED_MIME_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"];
const ALLOWED_EXTENSIONS = ["jpg", "jpeg", "png", "webp", "gif"];
const MAX_IMAGE_BYTES = 50 * 1024 * 1024; // 5MB

export default {
  props: ["field", "fields"],
  data() {
    return {
      existing_images: [],
      deleted_ids: [],
      new_images_files: [],
      new_images_preview: [],
      uploadError: "",
    };
  },
  computed: {
    hasImages() {
      return this.existing_images.length > 0 || this.new_images_files.length > 0;
    },
    hasDownloadableImages() {
      return this.existing_images.length > 0 || this.new_images_preview.length > 0;
    },
    maxSizeLabel() {
      return "50MB";
    },
  },
  mounted() {
    if (this.field.value && Array.isArray(this.field.value) && this.field.value.length > 0) {
      this.existing_images = JSON.parse(JSON.stringify(this.field.value));
    }
  },
  watch: {
    "field.value"(val) {
      if (val === "" || (Array.isArray(val) && val.length === 0)) {
        this.existing_images = [];
        this.deleted_ids = [];
        this.new_images_files = [];
        this.new_images_preview = [];
        this.emitValue();
      }
    },
  },
  methods: {
    resolveImageDownloadPath(img) {
      if (img?.path) {
        const rawPath = String(img.path).trim();
        if (/^https?:\/\//i.test(rawPath)) {
          try {
            return new URL(rawPath).pathname.replace(/^\//, "");
          } catch {
            return null;
          }
        }
        return rawPath.replace(/^\//, "");
      }
      if (img?.url) {
        try {
          return new URL(img.url).pathname.replace(/^\//, "");
        } catch {
          return null;
        }
      }
      return null;
    },
    getImageFilename(img, index, type) {
      if (type === "new" && this.new_images_files[index]?.name) {
        return this.new_images_files[index].name;
      }
      if (img?.path) {
        const parts = String(img.path).split("/").filter(Boolean);
        const fromPath = parts[parts.length - 1];
        if (fromPath && /\.(jpe?g|png|gif|webp|bmp|svg|ico)$/i.test(fromPath)) {
          return fromPath;
        }
        if (fromPath) return fromPath;
      }
      if (img?.url) {
        try {
          const parts = new URL(img.url).pathname.split("/").filter(Boolean);
          const fromUrl = parts[parts.length - 1];
          if (fromUrl) return decodeURIComponent(fromUrl);
        } catch {
          /* ignore */
        }
      }
      // Do not prefer img.name — it is often the original upload name without a useful
      // extension, or empty/wrong relative to the stored file path.
      if (img?.name && /\.(jpe?g|png|gif|webp|bmp|svg|ico)$/i.test(String(img.name))) {
        return img.name;
      }
      return `product-image-${index + 1}.jpg`;
    },
    triggerDownload(blob, filename) {
      const type = blob?.type || "";
      if (type.includes("text/html") || type.includes("application/json")) {
        throw new Error("Nuk u shkarkua fotoja.");
      }
      const safeName = ProductsServices.ensureImageFilename(filename, "product-image", type);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = safeName;
      a.type = type || "image/jpeg";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    async downloadImage(img, index, type) {
      const fallbackName = this.getImageFilename(img, index, type);
      try {
        if (type === "new" && this.new_images_files[index]) {
          this.triggerDownload(this.new_images_files[index], fallbackName);
          return;
        }
        // Existing images live on the backend domain and are served statically
        // without CORS headers, so fetching them directly is blocked. Go through
        // the API download endpoint (covered by CORS) instead.
        const { blob, filename } = await ProductsServices.downloadProductImage({
          id: img.id ?? null,
          path: this.resolveImageDownloadPath(img),
          fallbackName,
        });
        this.triggerDownload(blob, filename || fallbackName);
      } catch (e) {
        if (this.$toast?.error) {
          this.$toast.error(e?.message || "Nuk u shkarkua fotoja.");
        }
      }
    },
    async downloadAllImages() {
      const items = [...this.existing_images.map((img, idx) => ({ img, idx, type: "existing" })), ...this.new_images_preview.map((img, idx) => ({ img, idx, type: "new" }))];
      if (!items.length) return;
      for (const item of items) {
        await this.downloadImage(item.img, item.idx, item.type);
      }
      if (this.$toast?.success && items.length > 1) {
        this.$toast.success(`U shkarkuan ${items.length} foto.`);
      }
    },
    getFileExtension(file) {
      const name = String(file?.name || "");
      const parts = name.split(".");
      return parts.length > 1 ? parts.pop().toLowerCase() : "";
    },
    validateImageFile(file) {
      const ext = this.getFileExtension(file);
      const mimeOk = !file.type || ALLOWED_MIME_TYPES.includes(file.type);
      const extOk = ALLOWED_EXTENSIONS.includes(ext);
      if (!mimeOk && !extOk) {
        return `"${file.name}" nuk është format i lejuar. Përdorni JPG, PNG, WEBP ose GIF.`;
      }
      if (file.size > MAX_IMAGE_BYTES) {
        const sizeMb = (file.size / (1024 * 1024)).toFixed(1);
        return `"${file.name}" është ${sizeMb}MB. Madhësia maksimale është ${this.maxSizeLabel}.`;
      }
      return null;
    },
    handleFiles(e) {
      const files = Array.from(e.target.files || []);
      const errors = [];
      files.forEach((file) => {
        const error = this.validateImageFile(file);
        if (error) {
          errors.push(error);
          return;
        }
        this.new_images_files.push(file);
        this.new_images_preview.push({
          url: URL.createObjectURL(file),
          is_main: false,
        });
      });
      e.target.value = "";
      this.uploadError = errors.join(" ");
      if (errors.length && this.$toast?.error) {
        this.$toast.error(errors[0]);
      }
      this.emitValue();
    },
    markForDeletion(index) {
      const img = this.existing_images[index];
      this.deleted_ids.push(img.id);
      this.existing_images.splice(index, 1);
      this.uploadError = "";
      this.emitValue();
    },
    removeNew(index) {
      this.new_images_files.splice(index, 1);
      this.new_images_preview.splice(index, 1);
      this.uploadError = "";
      this.emitValue();
    },
    setMain(index, type) {
      this.existing_images.forEach((i) => (i.is_main = false));
      this.new_images_preview.forEach((i) => (i.is_main = false));

      if (type === "existing") {
        this.existing_images[index].is_main = true;
      } else {
        this.new_images_preview[index].is_main = true;
      }
      this.emitValue();
    },
    emitValue() {
      const mainIndexNew = this.new_images_preview.findIndex((i) => i.is_main);
      const mainIdExisting = this.existing_images.find((i) => i.is_main)?.id || null;

      const payload = {
        deleted_ids: this.deleted_ids,
        new_images: this.new_images_files,
        main_index_new: mainIndexNew,
        main_id_existing: mainIdExisting,
        hasAtLeastOneImage: this.existing_images.length + this.new_images_files.length > 0,
      };

      const updatedField = {
        ...this.field,
        value: payload,
      };
      this.$emit("syncField", updatedField);
    },
  },
};
</script>
